import { useTranslation } from 'react-i18next'

import { AnimatePresence, motion } from 'motion/react'

import { ComboBox, Divider, Text } from '@reveni-io/reveni-ui'

import NewShipmentSettings from '@/parcels/components/NewShipmentSettings/NewShipmentSettings'
import { lineItemStatuses } from '@/parcels/constants'

import { discardedItemsActionsOptions, discardedItemsActionsValues } from './constants'
import * as Styles from './styles'

const DiscardedItemsActions = ({
  lineItems,
  carrierServices,
  carrierServiceForNewShipment,
  setCarrierServiceForNewShipment,
  discardAction,
  setDiscardAction,
  locationForNewShipment,
  setLocationForNewShipment,
  senderLocation,
  locations,
}) => {
  const { t } = useTranslation()

  if (
    !lineItems?.length ||
    lineItems.every(item => item.newStatus !== lineItemStatuses.discarded) ||
    lineItems.every(item => item.newStatus === lineItemStatuses.discarded)
  ) {
    return null
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.4,
        }}
      >
        <Styles.MainContainer>
          <Text type="titleS">{t('Productos descartados')}</Text>
          <Text type="bodyMRegular">{t('¿Qué quieres hacer con los productos descartados de este envío?')}</Text>
          <ComboBox
            value={discardAction}
            handleChange={e => setDiscardAction(e.target.value)}
            menuItems={discardedItemsActionsOptions.map(o => ({ ...o, label: t(o.label) }))}
            fullWidth
          />
          <AnimatePresence>
            {discardAction === discardedItemsActionsValues.createNewShipment && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.4,
                }}
              >
                <NewShipmentSettings
                  carrierServices={carrierServices}
                  carrierServiceForNewShipment={carrierServiceForNewShipment}
                  setCarrierServiceForNewShipment={setCarrierServiceForNewShipment}
                  locationForNewShipment={locationForNewShipment}
                  setLocationForNewShipment={setLocationForNewShipment}
                  locations={locations}
                  senderLocation={senderLocation}
                />
              </motion.div>
            )}
          </AnimatePresence>
          <Divider />
        </Styles.MainContainer>
      </motion.div>
    </AnimatePresence>
  )
}

export default DiscardedItemsActions
